module.exports = __webpack_public_path__ + "static/media/no-image.ee4d78a8.png";